import { API_URL } from 'constants/config';
import callApi from 'utils/callApi';

export function getDynamicProfitOrderby(email, marketId, currentLongShort) {
  return callApi(
    `${API_URL}/Calculate/GetDynamicProfitOrderby?email=${email}&marketName=${marketId}&orderbyType=${currentLongShort}`
  );
}

// 股票chart資料
// MonthPeriod=0&positionType=1&IsBQ=true&MaxLong=99&MaxShort=-99 不知道是啥
export function getUserAiSMProfit(email, marketId, StrategyProfileId, positionType) {
  return callApi(
    `${API_URL}/Calculate/GetUserAiSMProfit?email=${email}&MarketName=${marketId}&StrategyProfileId=${StrategyProfileId}&MonthPeriod=0&positionType=${positionType}&IsBQ=true&MaxLong=99&MaxShort=-99`
  );
}
/*
0: "2021/09/08"
1: "48.7" 開盤價
2: "48.95" 最高價
3: "48.25" 最低價
4: "48.25" 收盤價
5: "-0.5" 
6: "-1.03"
7: "9770" 交易量
8: "3" 部位
9: "61.5" 損益
10: "0"

*/
